export const useChatOpened = () => useState('chatOpened', () => false)
export const useChatStarted = () => useState('chatStarted', () => false)

